import { Injectable } from '@angular/core';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';

import type { TNetPromoterScore } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class SatisfactionService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public async add(nps: TNetPromoterScore): Promise<TNetPromoterScore> {
        const path = this.firestorePathsService.getNetPromoterScoresPath();
        return this.firestoreService.add(path, nps) as Promise<TNetPromoterScore>;
    }
}
